import { withStyles } from '@material-ui/core/styles';
import Button from './Button';
import styles from './Button.styles';

export default withStyles(styles)(Button);
